import { Link } from 'react-router-dom';
import { config } from '@/lib/env';

/**
 * Links in the top right of the login screen: Contact and FAQ (US-001 AC-005), plus the Privacy Policy
 * and Terms & Conditions (PP-029 / proweb-102 AC-005).
 *
 * The two legal links are plain external links that open in a new tab (AC-005), which also keeps them
 * from disturbing a login already in progress. Their URLs come from configuration.
 */
export function SupportLinks(): React.JSX.Element {
  return (
    <nav aria-label="Support" className="flex flex-wrap gap-x-6 gap-y-1 text-sm">
      <Link to="/contact" className="text-brand-600 hover:text-gold-800">
        Contact
      </Link>
      <Link to="/faq" className="text-brand-600 hover:text-gold-800">
        FAQ
      </Link>
      <a
        href={config.privacyPolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-brand-600 hover:text-gold-800"
      >
        Privacy Policy
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
      <a
        href={config.termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-brand-600 hover:text-gold-800"
      >
        Terms &amp; Conditions
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
    </nav>
  );
}
